/* eslint-disable class-methods-use-this */
import * as api from '../../../../utils/apiClient';
import restructureResponse from '../../../../utils/restructureResponse';
import { restructureUserAnketaForm } from './restructuring';

class UserProfileService {
  async photoUpload(state, photo) {
    const formData = new FormData();
    formData.append(`avatarFile`, photo);
    const response = await api.post(`/user-profile/photo-upload`, {}, formData);
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: responseJson.data
    };
  }

  async photoRemove() {
    const response = await api.post(`/user-profile/photo-remove`, {}, {});
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: responseJson.data
    };
  }

  async getUserAnketaFormById(state, userId) {
    const response = await api.get(`/user-profile/${userId}`, {
      expand: 'city_geo_name'
    });
    const responseJson = await response.json();
    return restructureResponse(
      responseJson,
      responseJson.data,
      restructureUserAnketaForm
    );
  }

  async updateUserAnketaFormById(state, userId, body) {
    const response = await api.put(`/user-profile/${userId}`, {}, body);
    const data = await response.json();
    return data;
  }
}

export default new UserProfileService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/services/UserProfileService/UserProfileService.js